import React from 'react';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import { defaultEvent } from '../subscribers/helper';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const NotificationsActions = ({
  category,
  code,
  event,
  readStatus,
}) => {
  const eventCode = event || defaultEvent(category);
  const { allowRefresh } = Selectors.useNotificationsActions({ category });
  const refresh = Events.useRefreshNotifications(category, { code });

  return (
    <>
      {allowRefresh && (
        <RefreshActionMenu onClick={() => refresh({ event: eventCode, page: 1 })} readStatus={readStatus} />
      )}
    </>
  );
};

export default NotificationsActions;
